export const PRIVACY_LINK = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_57';

export const PROCESSING_LINK = 'https://static.cdn-cian.ru/frontend/info-assets/pik/soglasheniye_po_obrabotke.pdf';
